/**
 * Events:
 * "mfr:changed" - will fire when the quantity is changed. Event data will provide the current quantity
 *
 * Attributes:
 * - these data attributes can be manipulated
 * data-min - for the minimum quantity
 * data-max - for the maximum quantity
 *
 * Methods:
 * - .mfrQuantitySelector( "set-quantity", value )
 * - .mfrQuantitySelector( "get-quantity" )
 */
class QuantitySelector {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      input: ".quantity-selector__input",
      plus: ".quantity-selector__plus",
      minus: ".quantity-selector__minus",
      count: ".quantity-selector__count",
      unit: ".quantity-selector__unit",
      formContainer: ".product__form",
      buttonPrice: ".price-item"
    }

    this.init();
  }

  init() {
    this.$input = this.$element.find(this.selectors.input);
    this.$plus = this.$element.find(this.selectors.plus);
    this.$minus = this.$element.find(this.selectors.minus);
    this.$count = this.$element.find(this.selectors.count);
    this.$unit = this.$element.find(this.selectors.unit);

    this.$plus.on("click", this._handlePlus.bind(this));
    this.$minus.on("click", this._handleMinus.bind(this));
    this.addJqueryFunction();
  }

  _updateQuantity(value) {
    // Update the input value.
    this.$input.val(value);

    // Update the visual count.
    this.$count.text(value);

    this.$element.trigger( "mfr:quantity-changed", [ parseInt( this.$input.val() ) ] );
  }

  _handlePlus() {
    const currentCount = parseInt(this.$input.val());
    if (currentCount >= this.$element.data( "max" ) ) return;

    this._updateQuantity(currentCount + 1);
  }

  _handleMinus() {
    const currentCount = parseInt(this.$input.val());

    // Only decrease count when it's greater than the minimum.
    if ( currentCount > this.$element.data( "min" ) )
      this._updateQuantity(currentCount - 1);
  }

  addJqueryFunction() {
    const self = this;
    if( !jQuery ) return;

    jQuery.fn.extend({
      mfrQuantitySelector: function( method, value ) {
        if ( !$( this ).hasClass( "quantity-selector" ) ) {
          return $(this); // do nothing
        }
        if( method == "set-quantity" ) {
          self.$input.val( value );
          self.$count.text( value );
          self.$element.trigger( "mfr:quantity-changed", [ parseInt( self.$input.val() ) ] );
        }

        if( method == "get-quantity" ) return self.$input.val();

        return $(this);
      }
    })
  }
}

/**
 * Events:
 * "mfr:changed" - will fire when the variant is changed. Event data will be provide the variant max quantity and variant price
 *
 * Attributes:
 * - these data attributes can be manipulated
 * data-max - for the maximum quantity of the variant
 * data-price - for the price of the variant
 *
 * Methods:
 * - .mfrVariantSelector( "get-price" )
 */
class VariantSelector {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      hiddenInput: ".variant-selector__hidden-selector",
      options: ".variant-selector__options",
      option: ".variant-selector__option",
      jsonScript: ".variant-selector__variants-json[type='application/json']",
      optionInput: ".variant-selector__options label input",
      inputWrapper: ".variant-selector__variant-option",
      quantityJson: ".variant-selector__quantities-json[type='application/json']",
      stickyBar: ".product-sticky-bar__form", // Project specific
      tagline: ".dynamic-tagline", // Project specific
      productCarousel: ".product-top__images-carousel", // Project specific
      dynamicPrice: ".dynamic-price"
    };

    this.selectedOptions;
    this.variants;

    this.init();
  }

  init() {
    this.$input = this.$element.find(this.selectors.hiddenInput);
    this.$options = this.$element.find(this.selectors.options);
    this.$jsonScript = this.$element.find(this.selectors.jsonScript);
    this.$quantityJson = this.$element.find(this.selectors.quantityJson);
    this.$masterInput = $(`${this.$element.data("form")}`).find(
      "input[name='id']"
    );
    this.$optionInput = this.$element.find(this.selectors.optionInput);
    this.$inputWrapper = this.$element.find(this.selectors.inputWrapper);
    this.$dynamicPrice = $(this.selectors.dynamicPrice);

    // Project specific
    this.$stickyBar = $(this.selectors.stickyBar);
    this.$tagline = $(this.selectors.tagline);
    this.$productCarousel = $(this.selectors.productCarousel);

    if( !this.$element.length ) return;
    this.initVariants();
    this.addJqueryFunction();
    this.updateSelectedOptions();
    this.updateVariantStatuses();
    this.updateMasterId();
    this.updatePrice();

    this.$input.on("change", this.__handleVariantChange.bind(this));
    this.$optionInput.on("change", this.__handleOptionChange.bind(this));
  }

  __handleVariantChange() {
    const selector = this.$input;
    const selectedOption = selector.find("option:selected");
    const maxQuantity = selectedOption.data("max");
    const price = selectedOption.data("price");
    const options = selectedOption.data("options").split(",");
    this.$element.trigger("mfr:changed", [
      {
        max: maxQuantity,
        price: price,
        options: options,
      },
    ]);
  }

  __handleOptionChange() {
    this.updateSelectedOptions();
    this.updateVariantStatuses();
    this.updateMasterId();
    this.updateStickyBarSelectedVariantInput(this.currentVariant.id);  // Update the stickybar variant input
    this.updateCurentVariantTagline(this.currentVariant.title);
    this.updateCurentVariantMedia(this.currentVariant);
    this.updateCurentVariantInventory(this.currentVariant);
    this.updatePrice();
    // this.updateCurentVariantFeaturedImage(this.currentVariant)

    this.$element.trigger("mfr:changed", [
      {
        variantID: this.currentVariant.id,
        max: this.getQuantitiesData()[this.currentVariant.id],
        price: this.currentVariant.price.toFixed(2) / 100,
      },
    ]);
  }

  // Project specific
  updateStickyBarSelectedVariantInput(variantId) {
    let $selectedVariantInput = this.$stickyBar.find('input[name="id"]');

    if ( $selectedVariantInput.length > 0 ) {
      $selectedVariantInput.val(variantId);
    }
  }

  // Project specific
  updateCurentVariantTagline(variantTitle) {
    if ( this.$tagline.length > 0 ) {
      this.$tagline.text(variantTitle);
    }
  }

  // Project specific
  updateCurentVariantFeaturedImage(variant) {
    let variantMediaIndex = variant.featured_media.position - 1;

    if ( this.$productCarousel.length > 0 ) {
      this.$productCarousel.flickity('select', variantMediaIndex);
    }
  }

  // Project specific
  updateCurentVariantMedia(variant) {
    return false;
    const variants_media_array = window.variants_media_array;

    let selectedVariantMedia = variants_media_array.filter(item => item.id === variant.id);
    let selectedVariantFeaturedImage = selectedVariantMedia[0].featured_image;
    let newProductCarouselSlides = '';
    let sliderOptions = {
      wrapAround: false,
      prevNextButtons: true,
      adaptiveHeight: false,
      pageDots: true,
      selectedAttraction: 0.1,
      friction: 0.55,
      cellAlign: "center"
    }

    if ( this.$productCarousel.length > 0 ) {
      this.$productCarousel.flickity('destroy');

      newProductCarouselSlides += `
        <div class="product-top__image ${selectedVariantFeaturedImage.type}">
          <div class="product-image-component">
            <img src="${selectedVariantFeaturedImage.src}" alt="${selectedVariantFeaturedImage.alt}" loading="lazy" />
          </div>
        </div>
      `;

      selectedVariantMedia[0].media.forEach((item, index) => {
        newProductCarouselSlides += `
          <div class="product-top__image ${item.type}">
            <div class="product-image-component">
              <img src="${item.src}" alt="${item.alt}" loading="lazy" />
            </div>
          </div>
        `;
      });

      this.$productCarousel.html(newProductCarouselSlides);
      this.$productCarousel.flickity(sliderOptions);
      // window.replaceFlickityArrows();
    }
  }

  // Project specific
  updateCurentVariantInventory(variant) {
    const currentVariantAvailableQuantity = JSON.parse(this.$quantityJson.text())[variant.id];
    const $stickyFormAddToCart = this.$stickyBar.find('.add-to-cart')

    if ( currentVariantAvailableQuantity === 0 ) {
      $stickyFormAddToCart.prop('disabled', true).addClass('is-sold-out')
    } else {
      $stickyFormAddToCart.prop('disabled', false).removeClass('is-sold-out')
    }
  }

  updateSelectedOptions() {
    const options = [];
    this.$optionInput.each((i, e) => {
      const option = $(e);
      if (option.is(":checked")) {
        options.push(option.val());
      }
    });
    this.selectedOptions = options;
  }

  initVariants() {
    const variants = [];
    this.$input.find("option").each((i, e) => {
      const optionArr = $(e).data("options").split(",");

      variants.push(optionArr);
    });
    this.variants = variants;
  }

  updateHiddenInput() {
    this.$input.find("option").each((i, option) => {
      const optionsArray = $(option).data("options").split(",");
      if (this.arraysEqual(optionsArray, this.selectedOptions)) {
        this.$input.val($(option).val()).trigger("change");
      }
    });
  }

  arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.selectedOptions[index] === option;
        })
        .includes(false);
    });
    this.$masterInput.val(this.currentVariant.id);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.$jsonScript.text());
    return this.variantData;
  }

  getQuantitiesData() {
    this.quantitiesData =
      this.quantitiesData || JSON.parse(this.$quantityJson.text());
    return this.quantitiesData;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.getVariantData().filter(
      (variant) =>
        $(
          this.$element.find(`${this.selectors.optionInput}:checked`).get(0)
        ).val() === variant.option1
    );
    this.$inputWrapper.each((index, wrapper) => {
      if (index === 0) return;
      // const optionInputs = [
      //   ...option.querySelectorAll('input[type="radio"], option'),
      // ];
      const optionInputs = $(wrapper).find("input[type='radio']");
      const previousOptionSelected = $(this.$inputWrapper.get(index - 1))
        .find(":checked")
        .val();
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.each((index, input) => {
      if (listOfAvailableOptions.includes($(input).val())) {
        $(input).prop("disabled", false);
      } else {
        $(input).prop("disabled", true);
      }
    });
    this.$inputWrapper.each((index, wrapper) => {
      if(index === 0) return;
      if(!$(wrapper).find(
        "input[type='radio']:disabled:checked"
      ).length) return;

      const optionInput = $(wrapper).find(
        "input[type='radio']:not([disabled]):first"
      );
      optionInput.prop("checked", true);
    });
    this.updateSelectedOptions();
    this.updateMasterId();
    this.$element.trigger("mfr:changed", [
      {
        max: this.getQuantitiesData()[this.currentVariant.id],
        price: this.currentVariant.price.toFixed(2) / 100,
      },
    ]);
  }

  addJqueryFunction() {
    const self = this;
    if (!jQuery) return;
    jQuery.fn.extend({
      mfrVariantSelector: function (method, value) {
        if (!$(this).hasClass("variant-selector")) {
          return $(this); // do nothing
        }
        const selector = self.$input;
        const selectedOption = selector.find("option:selected");
        if (method == "get-price") return self.currentVariant.price.toFixed(2) / 100;

        return $(this);
      },
    });
  }

  updatePrice() {
    this.$dynamicPrice.html(
      Shopify.money_format.replace(
        "{{amount}}",
        this.currentVariant.price.toFixed(2) / 100
      )
    );
  }
}

/**
 * Events:
 * "mfr:changed" - will fire when the subscription is changed. Event data will be provide the discount price.
 */
class SubscriptionSelector {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      purchaseSelector: '[name="purchase_selector"]',
      planSelector: '[name="selling_plan"]',
      planSelectors: ".subscription-selector__options",
    };

    this.init();
  }

  init() {
    this.$purchaseSelector = this.$element.find(
      this.selectors.purchaseSelector
    );
    this.$planSelector = this.$element.find(this.selectors.planSelector);
    this.$planSelectors = this.$element.find(this.selectors.planSelectors);

    this.$purchaseSelector.on(
      "change",
      this.__handleSubscriptionChange.bind(this)
    );

    this.updatePlanStates();
    this.addJqueryFunction();
  }

  __handleSubscriptionChange() {
    const checkedInput = this.$element.find(
      `${this.selectors.purchaseSelector}:checked`
    );
    this.$element.trigger("mfr:subscription-changed", [
      {
        discount: checkedInput.data("price-discount"),
      },
    ]);

    this.updatePlanStates();
  }

  updatePlanStates() {
    const checkedInput = this.$element.find(
      `${this.selectors.purchaseSelector}:checked`
    );

    this.$planSelector.prop("disabled", checkedInput.val() != "subscription");
    this.$planSelectors.css(
      "pointer-events",
      checkedInput.val() != "subscription" ? "none" : ""
    );
  }

  addJqueryFunction() {
    const self = this;
    if (!jQuery) return;
    jQuery.fn.extend({
      mfrSubscriptionSelector: function (method, value) {
        if (!$(this).hasClass("subscription-selector")) {
          return $(this); // do nothing
        }

        if (method == "get-discount")
          return (
            self.$element
              .find(`${self.selectors.purchaseSelector}:checked`)
              .data("price-discount") ?? 0
          );

        if (method == "selected-option")
          return self.$element
            .find(`${self.selectors.purchaseSelector}:checked`)
            .val();

        return $(this);
      },
    });
  }
}

/**
 * For Submitting Product Form
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);

// jQuery( document )
//   .on( "mfr:styles-rendered", loadProductFormClasses )
//   .on( "shopify:section:load", loadProductFormClasses );

function loadProductFormClasses() {
  const productFormClasses = {
    ".quantity-selector": "QuantitySelector",
    ".variant-selector": "VariantSelector",
    ".subscription-selector": "SubscriptionSelector"
  }

  Object.entries( productFormClasses ).forEach((entry) => {
    const [ key, value ] = entry;
    initializeComponent( key, value );
  });
}
loadProductFormClasses();